module.exports = __webpack_public_path__ + "static/media/general5-2.09da9ca6.jpg";